export const SNOWPLOW = {
    SCHEMA: 'iglu:com.raisin/event_schema/jsonschema/1-0-3',
    TEST_ENDPOINT: 'com-raisin-prod1.mini.snplow.net',
    PROD_ENDPOINT: 'collector.raisin.com',
    TRACKER_ID: 'production',
    APP_IDS: {
        'www.weltsparen.de': 'prod',
        'www.weltsparen.at': 'prod_at',
        'www.raisin.com': 'prod_com',
        'www.raisin.com/pl-pl': 'prod_pl',
        'www.raisin.com/en-us': 'prod_us',
        'www.raisin.co.uk': 'prod_uk',
        'www.raisin.ie': 'prod_ie',
        'www.raisin.es': 'prod_es',
        'www.raisin.fr': 'prod_fr',
        'www.raisin.nl': 'prod_nl',
        'www.raisin.bank': 'prod_bank',
        'cap.weltsparen.de': 'cap_deu',
        'cap.raisin.co.uk': 'cap_gbr',
    },
};
export const EXPONEA = {
    PROD_TOKEN: {
        EU: '5ad5bb04-cff9-11ea-8069-62850c207816',
        GB: '3d293c22-f36a-11ea-922b-eafa027747e1',
    },
    TEST_TOKEN: {
        EU: 'b5ccc144-cb60-11ea-ba6c-9e994002a52c',
        GB: '65e07b30-f36a-11ea-9df7-4e6a9bf87271',
    },
    USER_CENTRICS_CONSENT_NAME: 'Exponea',
};
export const LOCAL_ENVS = [
    /^localhost/,
    /^core\.dev/,
    /raisin-dev/,
    /^bk-/,
    /bk\./,
    /staging-/,
    /amplifyapp/,
    /app.dev-raisin.com/,
];
export const GB_LOCALES = ['en_GB', 'en-GB'];
export const DE_LOCALES = ['de', 'de_DE', 'de-DE', 'at', 'de_AT', 'de-AT'];
export const COM_LOCALES = ['pl-pl', 'en-us'];
export const IDENTIFIED_USER_SESSION_NAME = 'user_is_identified';
export const COOKIE_FOR_SESSION_NAME = 'obs-session';
export const COOKIE_FOR_MOBILE_NAME = 'mobile';
export const AUTH_TOKEN_KEY = 'auth_token';
export const AUTH_TIME_DIFF_KEY = 'auth_time_diff';
//# sourceMappingURL=constants.js.map